import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import "./Dashboard.css";

/* =========================================================
   DUMMY DATA
========================================================= */
const INITIAL_STUDENTS = [
  { id: 1,  name: "Ravi Kumar",   class: "10-A", school: "Govt. High School",   status: "Active",   marks: 88, month: "Jan" },
  { id: 2,  name: "Neha Sharma",  class: "12-B", school: "City Public School",  status: "Active",   marks: 92, month: "Feb" },
  { id: 3,  name: "Arjun Verma",  class: "9-C",  school: "Saraswati Vidyalaya", status: "Pending",  marks: 76, month: "Feb" },
  { id: 4,  name: "Priya Singh",  class: "11-A", school: "Govt. Girls School",  status: "Active",   marks: 95, month: "Mar" },
  { id: 5,  name: "Rohit Yadav",  class: "10-B", school: "City Public School",  status: "Inactive", marks: 61, month: "Mar" },
  { id: 6,  name: "Anjali Gupta", class: "12-A", school: "Saraswati Vidyalaya", status: "Active",   marks: 89, month: "Apr" },
  { id: 7,  name: "Vikram Meena", class: "9-A",  school: "Govt. High School",   status: "Pending",  marks: 72, month: "Apr" },
  { id: 8,  name: "Sneha Patel",  class: "11-B", school: "Govt. Girls School",  status: "Active",   marks: 84, month: "May" },
  { id: 9,  name: "Karan Joshi",  class: "10-A", school: "City Public School",  status: "Active",   marks: 79, month: "May" },
  { id: 10, name: "Meera Rao",    class: "12-C", school: "Saraswati Vidyalaya", status: "Active",   marks: 91, month: "Jun" },
];

/* =========================================================
   MAIN COMPONENT
========================================================= */
function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [students, setStudents] = useState(INITIAL_STUDENTS);

  /* ---------- Stats ---------- */
  const stats = useMemo(() => {
    const total = students.length;
    const active = students.filter((s) => s.status === "Active").length;
    const pending = students.filter((s) => s.status === "Pending").length;
    const inactive = students.filter((s) => s.status === "Inactive").length;
    const avgMarks = total
      ? Math.round(students.reduce((a, s) => a + s.marks, 0) / total)
      : 0;
    return { total, active, pending, inactive, avgMarks };
  }, [students]);

  /* ---------- Filtered ---------- */
  const filteredStudents = useMemo(() => {
    return students.filter((s) => {
      const matchSearch =
        s.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        s.school.toLowerCase().includes(searchTerm.toLowerCase()) ||
        s.class.toLowerCase().includes(searchTerm.toLowerCase());
      const matchStatus = statusFilter === "All" || s.status === statusFilter;
      return matchSearch && matchStatus;
    });
  }, [students, searchTerm, statusFilter]);

  /* ---------- Chart Data ---------- */
  const classData = useMemo(() => {
    const map = {};
    students.forEach((s) => {
      map[s.class] = (map[s.class] || 0) + 1;
    });
    return Object.entries(map)
      .map(([label, value]) => ({ label, value }))
      .sort((a, b) => b.value - a.value)
      .slice(0, 7);
  }, [students]);

  const monthlyData = useMemo(() => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"];
    return months.map((m) => ({
      label: m,
      value: students.filter((s) => s.month === m).length,
    }));
  }, [students]);

  const pieData = [
    { label: "Active",   value: stats.active,   color: "#10b981" },
    { label: "Pending",  value: stats.pending,  color: "#f59e0b" },
    { label: "Inactive", value: stats.inactive, color: "#ef4444" },
  ];

  const topStudents = useMemo(
    () => [...students].sort((a, b) => b.marks - a.marks).slice(0, 5),
    [students]
  );

  /* ---------- Delete ---------- */
  const handleDelete = (id) => {
    if (window.confirm("Pakka delete karna hai?")) {
      setStudents((prev) => prev.filter((s) => s.id !== id));
    }
  };

  return (
    <div className={`dashboard-wrapper ${darkMode ? "dark" : ""}`}>

      {/* ============ OVERLAY (MOBILE) ============ */}
      {sidebarOpen && (
        <div className="dash-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ============ LAYOUT ============ */}
      <div className="dash-layout">

        {/* ============ SIDEBAR ============ */}
        <aside className={`dash-sidebar ${sidebarOpen ? "open" : ""}`}>
          {/* Brand */}
          <div className="sidebar-brand">
            <span className="brand-icon">
              <i className="fa fa-graduation-cap" />
            </span>
            <div>
              <small>STUDENT SCHOOL</small>
              <strong>DARPAN</strong>
            </div>
          </div>

          {/* Menu */}
          <nav className="side-menu-wrap">
            <ul className="side-menu">
              <li className="active">
                <Link to="/dashboard" onClick={() => setSidebarOpen(false)}>
                  <i className="fa fa-tachometer" />
                  <span>Dashboard</span>
                </Link>
              </li>
              <li>
                <Link to="/profile" onClick={() => setSidebarOpen(false)}>
                  <i className="fa fa-user" />
                  <span>My Profile</span>
                </Link>
              </li>
              <li>
                <Link to="/Student-Report" onClick={() => setSidebarOpen(false)}>
                  <i className="fa fa-users" />
                  <span>Students</span>
                </Link>
              </li>
              {/* <li>
                <Link to="/Staff_Report_Dashbord" onClick={() => setSidebarOpen(false)}>
                  <i className="fa fa-user-tie" />
                  <span>Staff</span>
                </Link>
              </li> */}
              {/* <li>
                <Link to="/School_Report_Dashbord" onClick={() => setSidebarOpen(false)}>
                  <i className="fa fa-building" />
                  <span>Schools</span>
                </Link>
              </li> */}

              {/* Red separator */}
              <li className="menu-divider" aria-hidden="true" />

              <li>
                <Link
                  to="/"
                  onClick={() => {
                    localStorage.clear();
                    sessionStorage.clear();
                    setSidebarOpen(false);
                  }}
                  className="logout-link"
                >
                  <i className="fa fa-sign-out" />
                  <span>Logout</span>
                </Link>
              </li>
            </ul>
          </nav>
        </aside>

        {/* ============ MAIN CONTENT ============ */}
        <main className="dash-main">

          {/* -------- TOPBAR -------- */}
          <header className="dash-topbar">
            <button
              type="button"
              className="dash-menu-btn"
              onClick={() => setSidebarOpen(true)}
            >
              <i className="fa fa-bars" />
            </button>

            <div className="topbar-title">
              <h1>Admin Dashboard</h1>
              <p>Welcome back, Administrator 👋</p>
            </div>

            <div className="topbar-actions">
              <button className="topbar-icon-btn" title="Notifications">
                <i className="fa fa-bell" />
                <span className="notif-dot" />
              </button>
              <div className="topbar-avatar">A</div>
            </div>
          </header>

          {/* -------- STATS -------- */}
          <section className="dash-stats">
            <StatCard color="blue"   icon="fa-users"        label="Total Students" value={stats.total}   trend="+12% this month" up />
            <StatCard color="green"  icon="fa-check-circle" label="Active"         value={stats.active}  trend="+5% this week"   up />
            <StatCard color="orange" icon="fa-clock-o"      label="Pending"        value={stats.pending} trend="-3% this week"   down />
            <StatCard color="purple" icon="fa-trophy"       label="Avg Marks"      value={`${stats.avgMarks}%`} trend="+2% this month" up />
          </section>

          {/* -------- CHARTS ROW 1 -------- */}
          <section className="dash-charts">
            <div className="chart-card">
              <div className="chart-header">
                <div>
                  <h3>Students per Class</h3>
                  <p>Distribution across classes</p>
                </div>
                <span className="chart-badge">Live</span>
              </div>
              <BarChart data={classData} />
            </div>

            <div className="chart-card">
              <div className="chart-header">
                <div>
                  <h3>Status Distribution</h3>
                  <p>Current student status</p>
                </div>
                <span className="chart-badge">Live</span>
              </div>
              <PieChart data={pieData} total={stats.total} />
            </div>
          </section>

          {/* -------- CHARTS ROW 2 -------- */}
          <section className="dash-charts">
            <div className="chart-card wide">
              <div className="chart-header">
                <div>
                  <h3>Monthly Enrollment Trend</h3>
                  <p>New students joined per month</p>
                </div>
                <span className="chart-badge success">+18% growth</span>
              </div>
              <LineChart data={monthlyData} />
            </div>

            <div className="chart-card">
              <div className="chart-header">
                <div>
                  <h3>Overall Performance</h3>
                  <p>Average across all students</p>
                </div>
              </div>
              <RadialProgress value={stats.avgMarks} />
            </div>
          </section>

          {/* -------- TOP + ACTIVITY -------- */}
          <section className="dash-charts">
            <div className="chart-card">
              <div className="chart-header">
                <div>
                  <h3>🏆 Top Performers</h3>
                  <p>Highest scoring students</p>
                </div>
              </div>
              <ul className="top-list">
                {topStudents.map((s, i) => (
                  <li key={s.id}>
                    <span className={`rank rank-${i + 1}`}>{i + 1}</span>
                    <div className="top-avatar">{s.name.charAt(0)}</div>
                    <div className="top-info">
                      <strong>{s.name}</strong>
                      <small>{s.class} • {s.school}</small>
                    </div>
                    <span className="top-marks">{s.marks}%</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="chart-card">
              <div className="chart-header">
                <div>
                  <h3>📅 Recent Activity</h3>
                  <p>Latest actions</p>
                </div>
              </div>
              <ul className="activity-list">
                <ActivityItem icon="fa-user-plus" color="blue"   text="New student Ravi Kumar added" time="2 min ago" />
                <ActivityItem icon="fa-pencil"    color="orange" text="Priya Singh's marks updated"   time="15 min ago" />
                <ActivityItem icon="fa-check"     color="green"  text="Arjun Verma approved"         time="1 hr ago" />
                <ActivityItem icon="fa-trash"     color="red"    text="Rohit Yadav removed"          time="3 hr ago" />
                <ActivityItem icon="fa-upload"    color="purple" text="Report exported to PDF"       time="5 hr ago" />
              </ul>
            </div>
          </section>

          {/* -------- TABLE -------- */}
          <section className="dash-table-section">
            <div className="table-header">
              <div>
                <h2>Students List</h2>
                <p>Manage all student records here</p>
              </div>

              <div className="table-controls">
                <div className="search-box">
                  <i className="fa fa-search" />
                  <input
                    type="text"
                    placeholder="Search student..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>

                <select
                  className="filter-select"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="All">All Status</option>
                  <option value="Active">Active</option>
                  <option value="Pending">Pending</option>
                  <option value="Inactive">Inactive</option>
                </select>

                <button className="add-btn">
                  <i className="fa fa-plus" /> Add Student
                </button>
              </div>
            </div>

            <div className="table-wrapper">
              <table className="dash-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Class</th>
                    <th>School</th>
                    <th>Marks</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredStudents.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="no-data">
                        <i className="fa fa-inbox" />
                        <p>No students found</p>
                      </td>
                    </tr>
                  ) : (
                    filteredStudents.map((s, i) => (
                      <tr key={s.id}>
                        <td>{String(i + 1).padStart(2, "0")}</td>
                        <td className="name-cell">
                          <div className="avatar">{s.name.charAt(0)}</div>
                          <span>{s.name}</span>
                        </td>
                        <td>{s.class}</td>
                        <td>{s.school}</td>
                        <td><strong>{s.marks}%</strong></td>
                        <td>
                          <span className={`status-badge ${s.status.toLowerCase()}`}>
                            {s.status}
                          </span>
                        </td>
                        <td className="action-cell">
                          <button className="icon-btn edit" title="Edit">
                            <i className="fa fa-pencil" />
                          </button>
                          <button
                            className="icon-btn delete"
                            title="Delete"
                            onClick={() => handleDelete(s.id)}
                          >
                            <i className="fa fa-trash" />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </section>

        </main>
      </div>
    </div>
  );
}

/* =========================================================
   SUB COMPONENTS
========================================================= */

function StatCard({ color, icon, label, value, trend, up, down }) {
  return (
    <div className={`stat-card ${color}`}>
      <div className="stat-icon"><i className={`fa ${icon}`} /></div>
      <div className="stat-content">
        <small>{label}</small>
        <strong>{value}</strong>
        <span className={`stat-trend ${up ? "up" : "down"}`}>
          <i className={`fa ${up ? "fa-arrow-up" : "fa-arrow-down"}`} /> {trend}
        </span>
      </div>
    </div>
  );
}

function ActivityItem({ icon, color, text, time }) {
  return (
    <li className="activity-item">
      <span className={`activity-icon ${color}`}><i className={`fa ${icon}`} /></span>
      <div className="activity-info">
        <strong>{text}</strong>
        <small>{time}</small>
      </div>
    </li>
  );
}

/* ---------- BAR CHART ---------- */
function BarChart({ data }) {
  const max = Math.max(...data.map((d) => d.value), 1);
  return (
    <div className="bar-chart">
      {data.map((d, i) => (
        <div className="bar-item" key={d.label}>
          <div className="bar-wrap">
            <div
              className="bar"
              style={{
                height: `${(d.value / max) * 100}%`,
                animationDelay: `${i * 80}ms`,
              }}
            >
              <span className="bar-value">{d.value}</span>
            </div>
          </div>
          <span className="bar-label">{d.label}</span>
        </div>
      ))}
    </div>
  );
}

/* ---------- PIE CHART ---------- */
function PieChart({ data, total }) {
  const totalVal = data.reduce((a, d) => a + d.value, 0) || 1;
  let cumulative = 0;

  const radius = 70;
  const cx = 90;
  const cy = 90;
  const strokeWidth = 26;

  return (
    <div className="pie-chart">
      <svg viewBox="0 0 180 180" className="pie-svg">
        <circle cx={cx} cy={cy} r={radius} fill="none" stroke="#e5e7eb" strokeWidth={strokeWidth} />
        {data.map((d) => {
          const percentage = d.value / totalVal;
          const dashArray = 2 * Math.PI * radius;
          const dashOffset = dashArray * (1 - percentage);
          const rotation = cumulative * 360 - 90;
          cumulative += percentage;

          return (
            <circle
              key={d.label}
              cx={cx}
              cy={cy}
              r={radius}
              fill="none"
              stroke={d.color}
              strokeWidth={strokeWidth}
              strokeDasharray={dashArray}
              strokeDashoffset={dashOffset}
              transform={`rotate(${rotation} ${cx} ${cy})`}
              strokeLinecap="round"
              style={{ transition: "stroke-dashoffset 1s ease" }}
            />
          );
        })}
        <text x={cx} y={cy - 4} textAnchor="middle" className="pie-total">{total}</text>
        <text x={cx} y={cy + 16} textAnchor="middle" className="pie-label">Total</text>
      </svg>

      <ul className="pie-legend">
        {data.map((d) => (
          <li key={d.label}>
            <span className="legend-dot" style={{ background: d.color }} />
            <span>{d.label}</span>
            <strong>{d.value}</strong>
          </li>
        ))}
      </ul>
    </div>
  );
}

/* ---------- LINE CHART ---------- */
function LineChart({ data }) {
  const width = 600;
  const height = 220;
  const padding = 40;
  const max = Math.max(...data.map((d) => d.value), 1);

  const points = data.map((d, i) => {
    const x = padding + (i * (width - padding * 2)) / (data.length - 1);
    const y = height - padding - (d.value / max) * (height - padding * 2);
    return { x, y, ...d };
  });

  const pathD = points
    .map((p, i) => (i === 0 ? `M ${p.x} ${p.y}` : `L ${p.x} ${p.y}`))
    .join(" ");

  const areaD = `${pathD} L ${points[points.length - 1].x} ${height - padding} L ${points[0].x} ${height - padding} Z`;

  return (
    <div className="line-chart">
      <svg viewBox={`0 0 ${width} ${height}`} className="line-svg">
        <defs>
          <linearGradient id="lineGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#7c3aed" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#7c3aed" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="strokeGradient" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#2563eb" />
            <stop offset="100%" stopColor="#7c3aed" />
          </linearGradient>
        </defs>

        {[0, 0.25, 0.5, 0.75, 1].map((r) => {
          const y = padding + r * (height - padding * 2);
          return (
            <line
              key={r}
              x1={padding}
              x2={width - padding}
              y1={y}
              y2={y}
              stroke="#e5e7eb"
              strokeDasharray="4 6"
            />
          );
        })}

        <path d={areaD} fill="url(#lineGradient)" />
        <path
          d={pathD}
          fill="none"
          stroke="url(#strokeGradient)"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {points.map((p, i) => (
          <g key={i}>
            <circle cx={p.x} cy={p.y} r="6" fill="#fff" stroke="#7c3aed" strokeWidth="3" />
            <text x={p.x} y={p.y - 14} textAnchor="middle" className="line-point-value">
              {p.value}
            </text>
            <text x={p.x} y={height - padding + 20} textAnchor="middle" className="line-label">
              {p.label}
            </text>
          </g>
        ))}
      </svg>
    </div>
  );
}

/* ---------- RADIAL PROGRESS ---------- */
function RadialProgress({ value }) {
  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - value / 100);

  return (
    <div className="radial-progress">
      <svg viewBox="0 0 180 180" className="radial-svg">
        <defs>
          <linearGradient id="radialGradient" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#2563eb" />
            <stop offset="100%" stopColor="#7c3aed" />
          </linearGradient>
        </defs>
        <circle cx="90" cy="90" r={radius} fill="none" stroke="#e5e7eb" strokeWidth="14" />
        <circle
          cx="90"
          cy="90"
          r={radius}
          fill="none"
          stroke="url(#radialGradient)"
          strokeWidth="14"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform="rotate(-90 90 90)"
          style={{ transition: "stroke-dashoffset 1.2s ease" }}
        />
        <text x="90" y="86" textAnchor="middle" className="radial-value">{value}%</text>
        <text x="90" y="108" textAnchor="middle" className="radial-label">Average</text>
      </svg>

      <div className="radial-legend">
        <div><span className="dot blue" /> <small>Target</small> <strong>90%</strong></div>
        <div><span className="dot green" /> <small>Achieved</small> <strong>{value}%</strong></div>
        <div><span className="dot gray" /> <small>Remaining</small> <strong>{100 - value}%</strong></div>
      </div>
    </div>
  );
}

export default Dashboard;